import { render } from "./UserSelectAccountView.vue?vue&type=template&id=23958fc1&scoped=true"
import script from "./UserSelectAccountView.vue?vue&type=script&lang=js"
export * from "./UserSelectAccountView.vue?vue&type=script&lang=js"

import "./UserSelectAccountView.vue?vue&type=style&index=0&id=23958fc1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23958fc1"]])

export default __exports__